import React, { useState } from 'react';
import api from '../api';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Card, CardBody, CardHeader } from './ui/Card';
import { useToast } from '../context/ToastContext';

export function PasswordChange({ token, labels }) {
  const { success, error: toastError } = useToast();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const checkStrength = (password) => {
    let s = 0;
    if (password.length >= 8) s++;
    if (/[A-Z]/.test(password)) s++;
    if (/[0-9]/.test(password)) s++;
    if (/[^A-Za-z0-9]/.test(password)) s++;
    return s;
  };

  const strength = checkStrength(newPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Please fill all fields');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (strength < 3) {
      setError('Use 8+ chars with uppercase, number, and special character');
      return;
    }
    setIsLoading(true);
    try {
      const res = await api.post('/change-password', { currentPassword, newPassword });
      if (!res.data?.success) throw new Error(res.data?.error || 'Failed');
      success('Password updated');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.response?.data?.error || err.message);
      toastError(err.response?.data?.error || err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader title={labels.changePassword} />
      <CardBody>
        <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
          <Input
            label="Current password"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            autoComplete="current-password"
          />
          <Input
            label="New password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
          />
          <div className="h-1.5 rounded-full bg-border overflow-hidden">
            <div
              className="h-full bg-primary transition-all"
              style={{ width: `${(strength / 4) * 100}%` }}
            />
          </div>
          <Input
            label="Confirm password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
          />
          {error && <p className="text-sm text-danger">{error}</p>}
          <Button type="submit" isLoading={isLoading} className="w-full sm:w-auto">
            {labels.save}
          </Button>
        </form>
      </CardBody>
    </Card>
  );
}
